export default function QuickLinks() {
  const links = [
    {
      icon: 'ri-meditation-line',
      title: '수행 프로그램',
      subtitle: '한국 전통 화두 참선 안내',
      description: '40년 전통의 참선 수행',
      color: 'from-amber-500 to-orange-600',
      link: '#programs',
    },
    {
      icon: 'ri-map-pin-2-line',
      title: '기원정사 성지',
      subtitle: '스라바스티 핵심 순례 코스',
      description: '연 1,000명 이상 순례객 방문',
      color: 'from-orange-500 to-red-600',
      link: '#pilgrimage',
    },
    {
      icon: 'ri-book-open-line',
      title: '교육 사업',
      subtitle: '지역 아이들을 위한 보광학교',
      description: '300명 이상 학생 교육',
      color: 'from-red-500 to-pink-600',
      link: '#education',
    },
  ];

  return (
    <>
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {links.map((item, index) => (
              <div
                key={index}
                className="group relative bg-gradient-to-br from-amber-50 to-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 border border-amber-100"
              >
                {/* Icon */}
                <div
                  className={`w-16 h-16 rounded-full bg-gradient-to-br ${item.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform`}
                >
                  <i className={`${item.icon} text-3xl text-white`}></i>
                </div>

                {/* Content */}
                <h3
                  className="text-2xl font-bold text-gray-900 mb-2"
                  style={{ fontFamily: "'Noto Serif KR', serif" }}
                >
                  {item.title}
                </h3>
                <p
                  className="text-amber-700 font-medium mb-3"
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  {item.subtitle}
                </p>
                {index === 2 ? (
                  <a
                    href="https://www.borisusesang.org/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-gray-600 mb-6 text-sm hover:text-amber-700 transition-colors cursor-pointer block"
                  >
                    300명 이상 학생 교육
                  </a>
                ) : (
                  <p className="text-gray-600 mb-6 text-sm">{item.description}</p>
                )}

                {/* Button */}
                <a
                  href={item.link}
                  className="inline-flex items-center gap-2 text-amber-700 font-semibold hover:text-amber-900 transition-colors group-hover:gap-3 cursor-pointer whitespace-nowrap"
                >
                  자세히 보기
                  <i className="ri-arrow-right-line"></i>
                </a>

                {/* Decorative Element */}
                <div className="absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-amber-100/50 to-transparent rounded-full blur-3xl -z-10"></div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Education Detail Section */}
      <section id="education" className="py-20 bg-gradient-to-b from-white to-amber-50">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Header */}
          <div className="text-center mb-16">
            <h2 
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-4"
              style={{ fontFamily: "'Noto Serif KR', serif" }}
            >
              보광 초·중등학교
            </h2>
            <p 
              className="text-xl text-amber-700 font-medium"
              style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
            >
              희망의 빛을 밝히는 교육
            </p>
          </div>

          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            {/* Text Content */}
            <div className="space-y-6">
              <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-lightbulb-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 
                      className="text-2xl font-bold text-gray-900 mb-2"
                      style={{ fontFamily: "'Noto Serif KR', serif" }}
                    >
                      부처님의 가르침을 실천하는 교육
                    </h3>
                    <p 
                      className="text-gray-700 leading-relaxed"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                    >
                      부처님의 깨달음과 자비의 가르침을 지역 사회에 회향합니다. 보광학교는 인도 스라바스티 지역 아이들에게 희망과 배움의 기회를 선사하는 교육의 터전입니다.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100">
                <div className="flex items-start gap-4 mb-4">
                  <div className="w-12 h-12 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-hand-heart-line text-2xl text-white"></i>
                  </div>
                  <div>
                    <h3 
                      className="text-2xl font-bold text-gray-900 mb-2"
                      style={{ fontFamily: "'Noto Serif KR', serif" }}
                    >
                      설립 배경
                    </h3>
                    <p 
                      className="text-gray-700 leading-relaxed mb-3"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                    >
                      전) 중앙승가대학교 교수 보각 스님께서 큰 원력을 세우시고, 한국 불자 사부대중의 뜻깊은 동참으로 학교가 세워졌습니다.
                    </p>
                    <p 
                      className="text-gray-700 leading-relaxed"
                      style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                    >
                      2013년 인도 정부의 허가를 얻어 사업가인 너윈 거사님과 아진트 신하 두 거사님의 지원으로 교육 법인 "보리수 세상"이 설립되어 학교 운영을 전담하고 있습니다.
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-gradient-to-br from-amber-500 to-orange-600 rounded-2xl p-8 shadow-lg text-white">
                <div className="flex items-center gap-4 mb-4">
                  <div className="w-12 h-12 bg-white/20 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-global-line text-2xl text-white"></i>
                  </div>
                  <h3 
                    className="text-2xl font-bold"
                    style={{ fontFamily: "'Noto Serif KR', serif" }}
                  >
                    보리수 세상 (Bodhi Tree World)
                  </h3>
                </div>
                <p 
                  className="text-white/90 leading-relaxed"
                  style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
                >
                  인도 학교 법인으로 등록되어 보광학교의 운영을 전담하며, 지역 아이들에게 양질의 교육을 제공하고 있습니다.
                </p>
                <a
                  href="https://www.borisusesang.org/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-6 bg-white text-amber-700 px-6 py-3 rounded-full font-semibold hover:bg-amber-50 transition-colors cursor-pointer whitespace-nowrap"
                >
                  보리수 세상 방문하기
                  <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>

            {/* Image Gallery */}
            <div className="grid grid-cols-2 gap-4">
              <div className="col-span-2 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://static.readdy.ai/image/bb60b64d4d14d0ba531f646d8a4266d5/5474b27a5f479b56beef6b567d99b8f0.jpeg"
                  alt="보광학교 학생들과 선생님"
                  className="w-full h-80 object-cover object-top"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://public.readdy.ai/ai/img_res/f205e66b3e1d52b6c4cb60def73639bd.jpg"
                  alt="보광학교 복도"
                  className="w-full h-64 object-cover object-top"
                />
              </div>
              <div className="rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://static.readdy.ai/image/bb60b64d4d14d0ba531f646d8a4266d5/7d618f12cfa64853eb6f1000c3f2d988.png"
                  alt="보광학교 안내판"
                  className="w-full h-64 object-cover object-top"
                />
              </div>
            </div>
          </div>

          {/* Statistics */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-user-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">300+</div>
              <p 
                className="text-gray-600"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                재학생 수
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-orange-500 to-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-calendar-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">2013</div>
              <p 
                className="text-gray-600"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                설립 연도
              </p>
            </div>

            <div className="bg-white rounded-2xl p-8 shadow-lg border border-amber-100 text-center">
              <div className="w-16 h-16 bg-gradient-to-br from-red-500 to-pink-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <div className="text-4xl font-bold text-gray-900 mb-2">희망</div>
              <p 
                className="text-gray-600"
                style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
              >
                지역 사회에 전하는 빛
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}